import styled from "styled-components";
import { CssRule } from "../../../../../../themes/architecture/css-helpers/css-rule";

export const FiltersMobileButtonsDefaultBox = styled.div`
    padding: 4rem 15%;
    margin-top: auto;
    padding: 2rem 25%;
    display: flex;
    flex-direction: column;

    ${CssRule.For.mobile.tablet.build()} & {
      padding: 2rem 5%;
    }

    ${CssRule.For.mobile.landscape.build()} & {
      flex-direction: row-reverse;
      justify-content: space-between;
    }

`;